import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import BoatsPage from '../pages/boats/page';
import CarsPage from '../pages/cars/page';
import CampersPage from '../pages/campers/page';
import MotorcyclesPage from '../pages/motorcycles/page';
import HousePage from '../pages/house/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/bateaux',
    element: <BoatsPage />
  },
  {
    path: '/voitures',
    element: <CarsPage />
  },
  {
    path: '/camping-cars',
    element: <CampersPage />
  },
  {
    path: '/motos',
    element: <MotorcyclesPage />
  },
  {
    path: '/maison',
    element: <HousePage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
